// src/production/components/RawMaterialForm.jsx
import React, { useState, useEffect } from 'react';
import { Box, Button, TextField, Typography } from '@mui/material';
import axios from 'axios';
import env from 'react-dotenv';

const RawMaterialForm = ({
  RM_name,
  RM_id,
  plan_id,
  job_card_id,
  product_id,
  openingQuantity,
  proceedQuantity,
  acceptedQuantity,
  rejectedQuantity,
  onSave,
  onCancel,
  cardDetails,
  currentStepStatus,
  departmentDetails,
  steps
}) => {
  const [openingQty, setOpeningQty] = useState(openingQuantity || '');
  const [proceedQty, setProceedQty] = useState(proceedQuantity || '');
  const [acceptedQty, setAcceptedQty] = useState(acceptedQuantity || '');
  const [rejectedQty, setRejectedQty] = useState(rejectedQuantity || '');
  const [nextStep, setNextStep] = useState('');

  const fetchOpeningQuantity = async (rmId, productId, useLocationInventory, currentStep) => {
    try {
      const url = useLocationInventory
        ? `${process.env.REACT_APP_PJCBACKEND_URL}/api/productionlocinventory/opening-quantity/${rmId}`
        : `${process.env.REACT_APP_PJCBACKEND_URL}/api/stepwiseinventory/opening-quantity-by-step/${rmId}?productId=${productId}&processName=${currentStep}`;
  
        const response = await axios.get(url);
        if (Array.isArray(response.data) && response.data.length > 0) {
          if (response.data[0].quantity !== undefined) {
            return response.data[0].quantity;
          }
        } else if (response.data && response.data.quantity !== undefined) {
          return response.data.quantity;
        }
        return 0;
    } catch (error) {
      console.error('Error fetching quantity:', error);
      return 0;
    }
  };
  
  useEffect(() => {
    const fetchQuantity = async () => {
      if (!RM_id || !product_id) return;
  
      const { dept_flag, dept_order, step_name } = currentStepStatus;
      const useLocationInventory = dept_flag === "0" && dept_order === 1;
  
      const openingQty = await fetchOpeningQuantity(RM_id, product_id, useLocationInventory, step_name);
      setOpeningQty(openingQty);
    };
  
    fetchQuantity();
  }, [RM_id, product_id, currentStepStatus]);  

  const handleSave = () => {
    // Convert quantities to numbers for comparison
    const openingQuantityNum = Number(openingQty);
    const proceedQuantityNum = Number(proceedQty);
    const acceptedQuantityNum = Number(acceptedQty);
    const rejectedQuantityNum = Number(rejectedQty);
    // Validation 1: Check if proceedQty > openingQty
    if (proceedQuantityNum > openingQuantityNum) {
      alert(`Please edit Processed quantity (Processed quantity should be less than or equal to Opening quantity: ${openingQuantityNum})`);
      return;
    }
    // Validation 2: Check if acceptedQty + rejectedQty > proceedQty
    if (acceptedQuantityNum + rejectedQuantityNum > proceedQuantityNum) {
      alert(`Please edit Accepted and Rejected quantity (Sum of Accepted quantity & Rejected quantity should be less than or equal to Processed quantity: ${proceedQuantityNum})`);
      return;
    }

    // const currentStepIndex = steps.findIndex(step => step.step_name === cardDetails.current_step_name);
    const currentStepOrder = currentStepStatus.step_order;

    const data = {
      RM_id,
      RM_name,
      openingQuantity: openingQty,
      proceedQuantity: proceedQty,
      acceptedQuantity: acceptedQty,
      rejectedQuantity: rejectedQty,
      process_name: cardDetails.current_step_name,
      next_step: nextStep,
      step_order: currentStepOrder,
      cardDetails,
      departmentDetails,
      steps
    };

    onSave(data);
  };

  return (
    <Box sx={{ mt: 6.5, mb: 27, p: 2, border: '1px solid #ccc', borderRadius: 2, width: '300px' }}>
      <Typography variant="body1" fontWeight="bold" sx={{ textAlign: 'center', mb: 2 }}>
        Raw Material Details for {RM_name}
      </Typography>

      <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
        <TextField
          label="Opening Quantity"
          type="number"
          value={openingQty}
          disabled
          fullWidth
        />
        <TextField
          label="Processed Quantity"
          type="number"
          value={proceedQty}
          onChange={(e) => setProceedQty(e.target.value)}
          fullWidth
        />
      </Box>

      <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
        <TextField
          label="Accepted Quantity"
          type="number"
          value={acceptedQty}
          onChange={(e) => setAcceptedQty(e.target.value)}
          fullWidth
        />
        <TextField
          label="Rejected Quantity"
          type="number"
          value={rejectedQty}
          onChange={(e) => setRejectedQty(e.target.value)}
          fullWidth
        />
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Button variant="contained" color="success" onClick={handleSave}>
          Save
        </Button>
        <Button variant="outlined" color="error" onClick={onCancel}>
          Cancel
        </Button>
      </Box>
    </Box>
  );
};

export default RawMaterialForm;
